<template>
  <div>
    <v-card v-if="activites.length > 0">
      <v-card-title>Activités :</v-card-title>
      <v-card-text>
        <template>
          <v-list>
            <v-list-item
              v-for="(item, index) in activites"
              :key="index"
              class="project"
            >
              <v-list-item-content>
                <v-list-item-title
                  v-html="item.abbr_parcours"
                ></v-list-item-title>
                <v-list-item-subtitle
                  >Activité : {{ item.ll_parcours }}</v-list-item-subtitle
                >
                <div>Programme: {{ item.ll_programme }}</div>
                <div>Thème: {{ item.ll_theme }}</div>
                {{ item.description_parcours }}

                <Etapes :activite="item" />
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </template>
      </v-card-text>
    </v-card>

    <div v-else>
      Pas d'activités
    </div>
  </div>
</template>

<script>
export default {
  components: {
    Etapes: require("@/components/organisation/etapes").default,
  },
  created() {
    this.getActiviteData(this.projet.id);
  },
  props: {
    projet: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      activites: [],
    };
  },
  methods: {
    getActiviteData(projetId) {
      let self = this;
      this.$firebase
        .firestore()
        .collection("activites")
        .where("programmes_id_programme", "in",[projetId.toString(),projetId] )
        .get()
        .then((snapshot) => {
          snapshot.docChanges().forEach((change) => {
            if (change.type === "added") {
              //console.log("New Doc: ", change.doc.data());
              self.activites.push({
                ...change.doc.data(),
                id: change.doc.id,
              });
            }
            if (change.type === "modified") {
              let obj = self.activites.find(
                (search) => search.id === change.doc.id
              );

              //bailleurs
              /*  obj.name = change.doc.data().abbr_bailleur;
                            obj.title = change.doc.data().ll_bailleur;
                            obj.ll_bailleur = change.doc.data().ll_bailleur;
                            obj.abbr_bailleur = change.doc.data().abbr_bailleur; */
            }
            if (change.type === "removed") {
              /*   console.log("Removed : ", change.doc.data());
                            let obj = elems.find((search) => search.id === change.doc.id);
                            const index = elems.indexOf(obj);
                            Vue.delete(elems, index); */
              //deleteProjetsDeBailleurs
            }
          });
        });
    },
  },
};
</script>

<style lang="scss" scoped></style>
